export const GET_TWO_FACTOR_METHODS = 'getTwoFactorMethods';
export const GET_MFA_SETTINGS = 'getMFASettings';
export const ENABLE_MFA = 'enableMFA';